import { SOCKET_EVENTS } from './socketEvents';
import TEMPLATES from './socketNotificationTemplates';
import * as pwaHelpers from '@/utils/pwaHelpers';
import { isEventPaused, isEventEnabled } from './socketManager';

export function getTemplateForEvent(eventName, payload) {
  const template = TEMPLATES[eventName];
  if (!template) return null;
  const title = typeof template.title === 'function' ? template.title(payload) : template.title;
  const message =
    typeof template.message === 'function' ? template.message(payload) : template.message;
  const pwaOptions =
    typeof template.pwaOptions === 'function' ? template.pwaOptions(payload) : template.pwaOptions;
  const toastOptions =
    typeof template.toastOptions === 'function'
      ? template.toastOptions(payload)
      : template.toastOptions;
  return {
    title,
    message,
    type: template.type,
    sound: template.sound,
    pwaOptions,
    toastOptions,
  };
}

export function playSoundIfNeeded(soundUrl) {
  try {
    if (!soundUrl) return;
    const audio = new Audio(soundUrl);
    audio.play().catch((e) => console.debug('[socketNotificationHelpers] Audio play error', e));
  } catch (e) {
    console.warn('[socketNotificationHelpers] Audio play failed', e);
  }
}

// Present notification using both in-app and PWA notification logic if available
export function presentSocketNotification({ eventName, payload, showNotification, options = {} }) {
  if (!isEventEnabled(eventName)) return;
  const tpl = getTemplateForEvent(eventName, payload);
  if (!tpl) return;
  if (showNotification && typeof showNotification === 'function' && tpl.toastOptions) {
    try {
      showNotification({
        title: tpl.toastOptions.title || tpl.title,
        message: tpl.toastOptions.message || tpl.message,
        severity: tpl.toastOptions.severity || tpl.type || 'info',
        position: tpl.toastOptions.position,
        duration: tpl.toastOptions.duration,
      });
    } catch (e) {
      console.error('[socketNotificationHelpers] showNotification error', e);
    }
  }
  // PWA style notification
  if (tpl.pwaOptions && pwaHelpers.showNotification) {
    try {
      pwaHelpers.showNotification(tpl.title, {
        body: tpl.pwaOptions.body,
        icon: tpl.pwaOptions.icon,
      });
    } catch (e) {
      console.debug('[socketNotificationHelpers] pwa showNotification error', e);
    }
  }
  // Play an audio cue if provided
  if (tpl.sound) {
    playSoundIfNeeded(tpl.sound);
  }
}

export default {
  getTemplateForEvent,
  presentSocketNotification,
  playSoundIfNeeded,
};
